<template>
  <div
    class="modal fade"
    ref="promptModal"
    tabindex="-1"
    aria-labelledby="aiPromptModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="aiPromptModalLabel">{{ title }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitPrompt">
            <div class="mb-3">
              <label for="ai-prompt" class="form-label">AI Review Prompt</label>
              <textarea
                id="ai-prompt"
                class="form-control"
                v-model="editablePrompt"
                rows="8"
              ></textarea>
              <div class="form-text">
                Optional. Leave as-is to use the default review prompt.
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                Cancel
              </button>
              <button type="submit" class="btn btn-primary">Generate review</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap';

// Teacher-facing modal to (re)generate an AI review with an optional custom prompt.
// Emits `generate(prompt)`; the parent panel calls the controller.
export default {
  name: 'AIPromptModal',
  props: {
    title: {
      type: String,
      default: 'Generate AI Review',
    },
    defaultPrompt: {
      type: String,
      default:
        "You are an expert teaching assistant. Provide a concise review of the student's submission. Write as the course teacher, directly addressing the student (use 'you'), with a professional, supportive tone. Only include specific issues or improvements grounded in the provided task description and logs. If there are no actionable issues, reply in one short sentence. Otherwise keep the review to at most 2 short sentences with concrete, actionable suggestions. Respond in plain text only; no Markdown.",
    },
  },
  data() {
    return {
      modalInstance: null,
      editablePrompt: this.defaultPrompt,
    };
  },
  mounted() {
    this.modalInstance = new Modal(this.$refs.promptModal);
  },
  methods: {
    show() {
      this.editablePrompt = this.defaultPrompt;
      if (this.modalInstance) this.modalInstance.show();
    },
    hide() {
      if (this.modalInstance) this.modalInstance.hide();
    },
    submitPrompt() {
      this.$emit('generate', this.editablePrompt);
      this.hide();
    },
  },
};
</script>
